import { IconBusiness360 } from '../../components/icons';

// Business 360 is internal prospect-discovery today — there's no tenant-scoped product surface
// yet (deferred to B360's customer phase). This is an honest "coming soon" so a tenant granted
// business360 sees an intentional page; it'll be replaced by the real product views (verified
// research + lead lists) the moment B360 ships a tenant-scoped API.
export function OverviewView() {
  return (
    <div className="page">
      <div className="page-header">
        <h1>Business 360</h1>
        <p className="sub">Verified prospect research and lead lists for your team.</p>
      </div>

      <div className="card" style={{ textAlign: 'center', padding: '48px 24px' }}>
        <div
          className="app-icon"
          style={{ background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', margin: '0 auto 18px', width: 52, height: 52 }}
        >
          <IconBusiness360 style={{ width: 26, height: 26 }} />
        </div>
        <h2 style={{ marginBottom: 8 }}>Coming soon</h2>
        <p className="muted" style={{ maxWidth: 460, margin: '0 auto 20px' }}>
          Business 360 finds and verifies prospects for you — every fact backed by a cited
          source. Your tenant workspace for research and lead lists is on the way.
        </p>
        <a className="btn" href="mailto:support@captomi.com?subject=Business%20360%20early%20access">
          Talk to us about early access
        </a>
      </div>
    </div>
  );
}
